import { Component, OnInit, inject } from '@angular/core';
import { EFeatureToggles, EStoreTypes } from '../../configurations/common';
import { ConfigurationFacade } from '../../facades/configuration.facade';
import { Observable } from 'rxjs';
import { AppUtils } from '../../utils/app.utils';

@Component({
  selector: 'app-page-shop-cart',
  templateUrl: './page-shop-cart.component.html',
  styleUrls: [],
  standalone: false,
})
export class PageShopCartComponent implements OnInit {
  private configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);

  protected readonly AppUtils: typeof AppUtils = AppUtils;
  protected readonly EStoreTypes: typeof EStoreTypes = EStoreTypes;
  isExportCartActive$: Observable<boolean> = new Observable<boolean>;
  isExternalQuoteCheckoutEnabled$: Observable<boolean> = new Observable<boolean>;

  ngOnInit(): void {
    this.isExportCartActive$ = this.configurationFacade.isFeatureEnabled(EFeatureToggles.CART_EXPORT_AS_PDF);
    this.isExternalQuoteCheckoutEnabled$ = this.configurationFacade.isFeatureEnabled(EFeatureToggles.EXTERNAL_QUOTE_CHECKOUT);
  }
}
